// ---------- la pub récompensée ----------
// Le point d'entrée unique de la monétisation : un indice coûte une pub regardée jusqu'au bout.
//
// Aujourd'hui, aucune régie n'est branchée et la promesse se tient tout de suite, sur le web
// comme sur Android. Le jour où AdMob arrive (comme dans Codigrid : @capacitor-community/admob),
// c'est CETTE fonction qui change, et rien d'autre : elle rendra `false` si le joueur ferme la pub
// avant la fin, et l'indice ne sera pas donné.
export async function watchRewarded(): Promise<boolean> {
  return true;
}
